export const DISCOUNT_TYPES = {
  NO_DISCOUNT: 1,
  FIXED: 2,
  PERCENTAGE: 3
}

export const PAYMENT_METHODS = {
  CARD: 1,
  INSTALLMENT: 2,
  DIRECT_TRANSFER: 3
}

export const BANNER_TYPES = {
  //Full size
  1: {
    sizes: [
      {
        desktop: {
          width: 100,
          height: 20.2
        },
        mobile: {
          width: 100,
          height: 43.9,
        }
      }
    ]
  },
  //Full size short
  2: {
    sizes: [
      {
        desktop: {
          width: 1644,
          height: 267
        },
        mobile: {
          width: 328,
          height: 120,
        }
      }
    ]
  },
  //Two image
  3: {
    sizes: [
      {
        desktop: {
          width: 100,
          height: 34
        },
        mobile: {
          width: 100,
          height: 32.9,
        }
      },
      {
        desktop: {
          width: 100,
          height: 34
        },
        mobile: {
          width: 100,
          height: 32.9,
        }
      }
    ]
  },
  //Three image
  4: {
    sizes: [
      {
        desktop: {
          width: 100,
          height: 68.7
        },
        mobile: {
          width: 100,
          height: 187.5,
        }
      },
      {
        desktop: {
          width: 100,
          height: 32.3
        },
        mobile: {
          width: 100,
          height: 91.25,
        }
      },
      {
        desktop: {
          width: 100,
          height: 32.3
        },
        mobile: {
          width: 100,
          height: 91.25,
        }
      }
    ]
  },
  //Three image 2
  5: {
    sizes: [
      {
        desktop: {
          width: 100,
          height: 52.63
        },
        mobile: {
          width: 100,
          height: 53.3,
        }
      },
      {
        desktop: {
          width: 100,
          height: 52.63
        },
        mobile: {
          width: 100,
          height: 53.3,
        }
      },
      {
        desktop: {
          width: 100,
          height: 52.63
        },
        mobile: {
          width: 100,
          height: 53.3,
        }
      },
    ]
  },
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm';